import React, { useState, useEffect } from 'react';
import { useCategoryList_Uploadpage } from './hooks';
//import { toast } from 'react-toastify'
import { Autocomplete, TextField } from '@mui/material';
import { sortDropdownOptions } from '../utils';

function FilterCategoryList({
	setCategory,
	Category,
	setCategoryId,
	CategoryId,
}) {
	const [options, setoptions] = useState([]);
	const expense_category_hook = useCategoryList_Uploadpage();
	const [Focus, setFocus] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [open, setOpen] = useState(false);
	const [firstTime, setfirstTime] = useState(true);

	useEffect(() => {
		if (expense_category_hook.hook.data) {
			setfirstTime(false);
			setoptions(sortDropdownOptions(expense_category_hook.hook.data.data.map((itm) => itm.name)));
		}	
	}, [expense_category_hook.hook.data, expense_category_hook.hook.isSuccess]);

	useEffect(() => {
		expense_category_hook.setArgs((args) => {
			return {
				...args,
				search: inputValue,
			};
		});
	}, [inputValue]);

	//const [CategoryId, setCategoryId] = useState('')

	function changeCategory(val) {
		//console.log(val);
		setCategory(val);
		let obj = expense_category_hook.hook.data.data.find((o) => o.name === val);
		//console.log(obj);
		if (obj) {
			setCategoryId(obj._id);
		}
		else{
			setCategoryId(null)
			setCategory(null)
		}
	}

	let stop = false;

	return (
		<>
			<div>
				<div className="flex gap-3">
					<div className="grow">
						<div className="lightT">
							{firstTime && expense_category_hook.hook.isPending ? (
								<p className="px-4 py-2 border border-1 border-slate-300 rounded-md">
									Expense Category{' '}
									<span className="text-sm text-slate-400 ps-4 inline-block">
										Loading...
									</span>
								</p>
							) : (
								<Autocomplete
									isOptionEqualToValue={(option, value) =>
										option === value || value === '' || value == null
									}
									disablePortal
									id="combo-box-demo"
									filterOptions={(x) => x}
									options={options}
									value={Category}
									open={open}
									onOpen={() => {
										setOpen(true);
									}}
									onClose={() => {
										setOpen(false);
									}}
									renderInput={(params) => (
										<TextField {...params} label="Expense Category *" />
									)}
									onChange={(event, value) => changeCategory(value)}
									onInputChange={(event, newInputValue) => {
										setInputValue(newInputValue);
									}}
									onFocus={() => setFocus(true)}
									onBlur={() => setFocus(false)}
									renderOption={(props, option) => {
										if (stop) return;
										if (expense_category_hook.hook.isPending) {
											stop = true;
											return (
												<p key={'loading_category'} className="ml-2">
													Loading...
												</p>
											);
										}

										return (
											<li key={option} {...props}>
												{option}
											</li>
										);
									}}
								/>
							)}
							{Category == null && Focus && (
								<small className="text-red-600 ">
									Expense category is required
								</small>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default FilterCategoryList;
